import React, { useState, useEffect, useCallback } from 'react'
import { Button, Select, DatePicker, Modal } from '@ow/comps'
import { reportTask } from '@vt/apis/lib-ex/v2/givrali'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import { pick, get } from 'lodash-es'
import locale from '@ow/comps/locale/zh-CN'

const GenerateReport = function () {
  const [openFlag, setOpenFlag] = useState(false)
  const { getDitto } = useAppEx((state) => pick(state, ['getDitto']))

  const { fetchTbData, reporterConfig } = useTbViewStore((state) =>
    pick(state, ['fetchTbData', 'reporterConfig'])
  )
  const ids = get(reporterConfig, 'mpIds', [0])
  const isReportType = get(reporterConfig, 'reportType', false)
  const optionsArr = get(reporterConfig, 'options', [])
  const originTid = get(reporterConfig, 'originTid', 0)
  const targetTid = get(reporterConfig, 'targetTid', 0)
  const appendTids = get(reporterConfig, 'appendTids', [])
  const [standardData, setStandardData] = useState({})
  const [reportType, setReportType] = useState(ids)
  const [repoetDate, setRepoetDate] = useState(null)
  const fetchData = async () => {
    const data = await getDitto('standard').fetchTbData({ pageSize: 10000 })
    const newObj = {}
    data.forEach((item) => {
      if (optionsArr.indexOf('居民小区日报')) {
        newObj[16] = item.objectId
        if (item.title === '居民小区') {
          newObj[16] = item.objectId
        }
      }
      if (optionsArr.indexOf('行政村日报')) {
        if (item.title === '行政村') {
          newObj[17] = item.objectId
        }
      }
      if (item.title === '居民小区') {
        newObj[14] = item.objectId
      }
      if (item.title === '社会单位') {
        newObj[13] = item.objectId
      }
      if (item.title === '密闭式清洁站') {
        newObj[11] = item.objectId
      }
      if (item.title === '清运车辆') {
        newObj[12] = item.objectId
      }
      if (item.title === '行政村') {
        newObj[15] = item.objectId
      }
    })
    setStandardData(newObj)
  }

  useEffect(() => {
    fetchData()
  }, [])
  const childQueries = [
    {
      queryType: 'just',
      queryOperate: {
        slug: 'createdAt',
        operator: 'gte',
        rightValue: repoetDate
          ? repoetDate.getTime()
          : new Date(new Date().toLocaleDateString()).getTime(),
      },
    },
    {
      queryType: 'just',
      queryOperate: {
        slug: 'createdAt',
        operator: 'lte',
        rightValue: repoetDate
          ? repoetDate.getTime() + 24 * 60 * 60 * 1000 - 1
          : new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1,
      },
    },
    {
      queryType: 'or',
      childQueries: [
        {
          queryType: 'just',
          yacQueryOperate: {
            operator: 'contain',
            left: {
              slug: 'standard',
            },
            right: {
              value: reportType[0] && standardData[reportType[0]],
            },
          },
        },
      ],
    },
  ]
  const FooterComp = useCallback(
    () => (
      <Button
        type="primary"
        onClick={() => {
          setOpenFlag(false)
          fetchTbData()
        }}
      >
        确定
      </Button>
    ),
    []
  )
  const generateReport = () => {
    const send = {
      mpIds: reportType,
      dsl: {
        queryType: 'and',
        childQueries,
      },
      // 数据来源表单id
      originTid,
      // 报告存储目标id
      targetTid,
      appendTids,
    }
    reportTask(send).then(() => {
      setOpenFlag(true)
    })
  }
  const onChangeSelect = ({ value }) => {
    setReportType([value])
  }

  return (
    <div className="flex w-full pl-5">
      <DatePicker
        locale={locale}
        placeholder="请选择生成报告日期"
        selectedDateBackground="rgb(var(--ow-primary-color))"
        onChange={(date) => {
          setRepoetDate(date)
        }}
      />
      {isReportType && optionsArr.length ? (
        <div className="ml-5" style={{ width: '230px' }}>
          <Select
            options={optionsArr}
            onChange={onChangeSelect}
            noOptionsMessage={() => {
              return '暂无数据'
            }}
          />
        </div>
      ) : (
        <div className="ml-5" style={{ width: '230px' }}>
          <Select
            options={[
              { value: 14, label: '居民小区日报' },
              { value: 13, label: '社会单位日报' },
              { value: 11, label: '密闭式清洁站日报' },
              { value: 12, label: '清运车辆日报' },
              { value: 15, label: '行政村日报' },
            ]}
            onChange={onChangeSelect}
            noOptionsMessage={() => {
              return '暂无数据'
            }}
          />
        </div>
      )}

      <Button
        className="flex items-center justify-center font-medium mr-2 ml-2"
        style={{
          height: '35.5px',
          padding: '0.55rem',
          borderRadius: '4px',
          ':hover': {
            opacity: 1,
          },
        }}
        disabled={!reportType}
        onClick={generateReport}
        type="primary"
        textColor="rgb(var(--ow-text-inverse-color))"
      >
        生成报告
      </Button>
      <Modal
        nested
        open={openFlag}
        size="sm"
        onClose={() => setOpenFlag(false)}
        footer={FooterComp}
      >
        <div
          className="w-full flex flex-col items-center"
          style={{ fontSize: '0.8125rem' }}
        >
          <div className="flex items-center">操作成功</div>
          <div className="w-full text-white-400 mt-4 flex justify-between items-center">
            <div>请等待几分钟后刷新界面进行任务下载</div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default GenerateReport
